module.exports = __webpack_public_path__ + "static/media/send.9dc5517d.svg";